import { render, staticRenderFns } from "./contentCourseLectureVideo.vue?vue&type=template&id=3c92c03f&"
import script from "./contentCourseLectureVideo.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports